import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SlideIn, SubmitButton } from 'components';
import { Heading } from 'components/chroma';

import NameQuestion from 'scenes/common/components/Questions/NameQuestion';

import { MotorFlowType, MotorFullPageProps } from 'scenes/motor/types';
import { getName, isMainDriver } from 'scenes/motor/selectors';

const FIRST_NAME = 'firstName';
const LAST_NAME = 'lastName';

const firstNameQuestion = (mainDriver: boolean, flowType: MotorFlowType) => {
  if (flowType === MotorFlowType.AddPolicyHolder) {
    return 'What is the first name of the additional policy holder?';
  }
  return mainDriver
    ? 'What is the first name of the main driver?'
    : 'What is the first name of the additional driver?';
};

const secondNameQuestion = (mainDriver: boolean, flowType: MotorFlowType) => {
  if (flowType === MotorFlowType.AddPolicyHolder) {
    return 'What is the last name of the additional policy holder?';
  }
  return mainDriver
    ? 'What is the last name of the main driver?'
    : 'What is the last name of the additional driver?';
};

const NameStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNextNoAutoFormMerge,
  flowType,
}) => {
  const {
    formState: hooksForm,
    handleSubmit,
    control,
    errors,
    watch,
  } = useForm({
    mode: 'onChange',
  });

  const mainDriver = isMainDriver(funnelState);
  const { firstName, lastName } = getName(funnelState);
  const watchedFirstName = watch(FIRST_NAME, firstName);

  return (
    <form onSubmit={handleSubmit(onNextNoAutoFormMerge)} autoComplete="on">
      {flowType !== MotorFlowType.AddPolicyHolder && (
        <Heading size={3}>Driver details</Heading>
      )}
      <NameQuestion
        errors={errors}
        control={control}
        stateKey={FIRST_NAME}
        defaultValue={firstName ?? ''}
        autoCompleteName="given-name"
        question={firstNameQuestion(mainDriver, flowType)}
      />

      {Boolean(watchedFirstName) && (
        <SlideIn>
          <NameQuestion
            stateKey={LAST_NAME}
            errors={errors}
            control={control}
            question={secondNameQuestion(mainDriver, flowType)}
            defaultValue={lastName ?? ''}
            autoCompleteName="family-name"
          />
        </SlideIn>
      )}
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default NameStep;
